import ReactHtmlParser from "html-react-parser";
import { useState } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ButtonMob } from "../../../utils/utils";
import StepProgressBar from "./steps-progress-bar";

const PreValuationSteps = ({ onCancel, onConfirm }) => {
  const stepContents = [
    {
      title: "Paso 1: Composición Corporal",
      boldText: "Sube al usuario a la báscula",
      description:
        "<strong>Sube al usuario a la báscula</strong> y da inicio al análisis de su composición corporal.<br/>Esto nos permitirá obtener datos clave sobre su estado físico actual.",
    },
    {
      title: "Paso 2: Frecuencia Cardíaca en Reposo",
      boldText: "Toma la frecuencia cardíaca",
      description:
        "Accede al <strong> panel HR </strong> de la app del usuario y <strong> realiza una medición en modalidad reposo </strong> durante <strong> 3 minutos ininterrumpidos. </strong> <br/>  <br/> Este valor servirá como referencia para su condición cardiovascular basal.",
    },
    {
      title: "Paso 3: Prueba de Recuperación Cardíaca",
      boldText: "Realiza una actividad breve",
      description:
        "<strong> Instrucciones </strong> <br/> <br/> 1. Accede al panel HR de la app del usuario y realiza una medición en modalidad prueba de recuperación. <br/>  <br/> 2. Inicia la prueba y <strong> lleva a tu usuario al máximo rendimiento cardiovascular </strong> (zona 5) <strong> durante 5 minutos continuos </strong> (puede ser en caminadora, bici o ejercicio funcional, o el de tu elección, recuerda hacer esta prueba con el mismo ejercicio cada vez que la hagas).  <br/>  <br/> 3. Al momento de llegar al minuto 5 detén la actividad de tu usuario y sin finalizar la prueba de HR monitorea los próximos 5 minutos en reposo. <br/>  <br/> 4. El reposo debe ser por 5 minutos más (sin hablar, caminar o moverse). <br/>  <br/> 5. Después de estos 5 minutos finaliza la sesión.",
    },
    {
      title: "Paso 4: Confirmación",
      boldText: "Revisa los datos ingresados",
      description:
        "Se ha finalizado exitosamente el protocolo de medición corporal y de frecuencia cardíaca en reposo y recuperación. <br/> <br/> Los datos obtenidos proporcionan una base confiable para el registro y análisis del estado físico del atleta. <br/> <br/> Puedes continuar con el ingreso de <strong> información avanzada y la definición de objetivo. </strong>",
    },
  ];
  const [step, setStep] = useState(1);
  const [showXMark, setShowXMark] = useState(true);
  const totalSteps = stepContents.length;
  const currentStepData = stepContents[step - 1];

  const sendData = () => {
    onCancel();
  };
  const onNext = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    } else {
      sendData();
    }
  };

  return (
    <div className="container py-0">
      {/* Alerta superior */}
      {showXMark && (
        <div
          className="alert alert-warning d-flex align-items-start"
          role="alert"
        >
          <i
            className="bi bi-exclamation-triangle-fill text-warning me-2"
            style={{ fontSize: "1.5rem" }}
          ></i>
          <div
            style={{ textAlign: "left" }}
            className="input-tooltip-valoration-steps "
          >
            <strong>Importante seguir estos pasos</strong>
            <p className="mt-1">
              Para garantizar un seguimiento preciso, asegúrate de realizar esta
              medición. <br />
              Si omites este paso, se conservará la última registrada y no
              podrás visualizar la evolución real del atleta en su historial ni
              en sus reportes de progreso.
            </p>
          </div>
          <span
            className="ms-auto cursor-pointer"
            onClick={() => setShowXMark(!showXMark)}
          >
            <strong>X</strong>
          </span>
        </div>
      )}

      {/* Título principal */}
      {step == 1 && (
        <div className="text-center my-4 input-tooltip-valoration-steps ">
          <h4 className="fw-bold">
            Completa los pasos previos <br /> antes de la valoración
          </h4>
          <p>
            <strong>Antes de empezar</strong> la valoración, asegúrate de
            realizar la medición corporal, la frecuencia cardíaca en reposo y la
            prueba de recuperación.
          </p>
          <p>
            Estos pasos son <strong>esenciales</strong> para obtener una
            evaluación completa y precisa.
          </p>
        </div>
      )}

      {/* Indicador de pasos con línea de progreso */}
      <StepProgressBar step={step} totalSteps={totalSteps} />
      <hr />

      {/* Contenido del paso actual */}
      <div className="mb-4 w-full" style={{ textAlign: "left" }}>
        <h5 className="fw-bold">{currentStepData?.title}</h5>
        <p>
          <span className="text-muted input-tooltip-valoration-steps ">
            {ReactHtmlParser(currentStepData?.description || "")}
          </span>
        </p>
      </div>

      {/* Botón siguiente */}
      <div
        className="d-flex justify-content-center gap-2 mx-auto"
        style={{ width: "50%" }}
      >
        <ButtonMob
          handleClick={step === totalSteps ? onConfirm : onNext}
          colorButton={"var(--elevvabutonLogin_User)"}
          borderbutton="1px solid var(--elevvabutonLogin_User)"
          text={step === totalSteps ? "Finalizar" : "Siguiente"}
          className={"  px-2"}
          sizeFont=" calc(0.3rem + 0.3vw)"
        />
      </div>
    </div>
  );
};

export default PreValuationSteps;
